export const DRAW_REVIEW_STATE = {
  APPROVED: "APPROVED",
  NO_REVIEWERS: "NO_REVIEWERS",
  PENDING: "PENDING",
};
